import { SectionParagraph } from '@/components/shared/Content';
import { Box, themedColor } from '@lemonade-hq/cdk';
import { rgba } from 'polished';
import styled, { type DefaultTheme } from 'styled-components';

const FooterContainer = styled(Box)`
  background: ${themedColor('darkestNight')};
  color: ${({ theme }: { theme: DefaultTheme }) => rgba(theme.colors.metal, 0.5)};
`;

const FooterContent = styled(SectionParagraph)`
  margin: auto;
  max-width: 1246px;
  font-size: 1.4rem;
  line-height: 2.1rem;
  text-align: left;
  span {
    display: block;
    margin-bottom: 10px;
  }
`;

export const ComparisonDisclaimer: React.FC = () => (
  <FooterContainer px={[20, 20, 60]} pb={[40, 40, 60]} mt={[-1]}>
    <FooterContent>
      <span>
        Comparison information is provided using publicly available information as of May 2025 and is only meant to
        summarize program features, not a specific plan. Review the provider’s plan terms for more details. The
        description of the providers’ plans are not provided by that company. If you have questions about other plans,
        please contact an agent of that company. It is our intention to provide fair and accurate comparison
        information. We attempt to keep information up to date but it may change from time to time. If you are aware of
        any inaccuracies or changes in the information provided, let us know by emailing help@lemonade.com.
      </span>
      <span>
        This product information is for descriptive purposes only and does not provide a complete summary of any
        company’s coverage. Consult the applicable insurance policy for specific terms, conditions, limits, deductible,
        copay, limitations, and exclusions to coverage; these may vary by state and are subject to change without
        notice. The coverage for each policyholder will be governed by the terms and conditions of the applicable
        policy. All coverage and limit options may not be available to all customers and are subject to underwriting
        approval. If there is any conflict between the policy and this product information, the provisions of the policy
        shall prevail.
      </span>

      <span>
        For the full terms of Lemonade pet Insurance policies visit https://www.lemonade.com/pet. Products and rates may
        vary and are subject to change. Discounts may vary and are subject to change.
      </span>

      <span>
        Residents of DE, LA, ME, MS, NE, NH, WA, will receive an Insurer Disclosure of Important Policyholder Provisions
        in the quote flow and policy documents.
      </span>

      <span>
        Property and casualty insurance is provided by Lemonade Insurance Company (LIC), 5 Crosby St., 3rd floor, New
        York, NY 10013 or Metromile Insurance Company (MIC), 3080 N. Civic Center Plaza, Scottsdale, AZ 85251.
      </span>

      <span>
        Lemonade Insurance Agency, LLC (LIA) and Metromile Insurance Services LLC (MIS) are licensed insurance agents
        and appointed by LIC and MIC and both LIA and MIS receive compensation based on the premiums for the insurance
        policies each sells. Further information is available upon request.
      </span>
    </FooterContent>
  </FooterContainer>
);
